"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _react = _interopRequireDefault(require("react")),
  _default = exports["default"] = function (a) {
    var b = a.field,
      c = a.saveStateToHtmlField,
      d = a.hideField,
      e = a.styledComponents,
      f = b.content,
      g = b.label,
      h = b.cssClass,
      j = b.width;
    if (c) {
      var k = c.saveStateToHtmlField,
        l = c.formValues,
        m = Object.keys(k),
        n = [];
      if (m) for (var o in l) for (var p = l[o], q = 0; q < m.length; q++) -1 === p.cssClass.indexOf(m[q]) || p.valid || (n[k[m[q]]] = p.value);
      if (n) for (var r = Object.keys(n), s = 0; s < r.length; s++) "%price%" === r[s] && (n[r[s]] = "\u20AC".concat(n[r[s]])), f = f.replace(r[s], n[r[s]]);
    }
    var t = e || !1,
      u = t.Box,
      v = void 0 === u ? "div" : u,
      w = t.Label,
      x = void 0 === w ? "label" : w;
    return _react["default"].createElement(v, {
      width: j,
      className: "form-field ".concat(h),
      style: {
        display: d ? "none" : void 0
      }
    }, _react["default"].createElement(x, {
      className: "gf-label"
    }, g), _react["default"].createElement("div", {
      className: "html-content",
      dangerouslySetInnerHTML: {
        __html: f
      }
    }));
  };